import { connect } from 'react-redux';

import { checkUserExist, login, register, resendOtp, resendVerifyMail } from '@common/redux/auth/actions';
import { setAuthenticatedFlag } from "@common/redux/auth/actions";
import { ICheckUserExist, ILoginPayload, IResendOtpPayload } from '@common/redux/auth/interface';
import { checkUserExistErrorSelector, checkUserExistLoaderSelector, checkUserExistSelector, loginErrorSelector, loginLoaderSelector, loginSelector, registerErrorSelector, registerLoaderSelector, registerSelector, resendOtpErrorSelector, resendOtpLoaderSelector, resendOtpSelector, resendVerifyMailErrorSelector, resendVerifyMailLoaderSelector, resendVerifyMailSelector } from '@common/redux/auth/selectors';

import SelfRegister from '@presentation/auth/SelfRegister';

import { IState } from '@store/webInterfaces';

const mapStateToProps = (state: IState) => ({
    checkUserExistData: checkUserExistSelector(state),
    checkUserExistError: checkUserExistErrorSelector(state),
    isCheckingUserExists: checkUserExistLoaderSelector(state),

    isRegisteringUser: registerLoaderSelector(state),
    registerUserError: registerErrorSelector(state),
    registerUserData: registerSelector(state),

    resendVerifyMailData: resendVerifyMailSelector(state),
    resendVerifyMailLoader: resendVerifyMailLoaderSelector(state),
    resendVerifyMailError: resendVerifyMailErrorSelector(state),

    loginLoader: loginLoaderSelector(state),
    loginData: loginSelector(state),
    loginError: loginErrorSelector(state),

    resendOtpLoader: resendOtpLoaderSelector(state),
    resendOtpData: resendOtpSelector(state),
    resendOtpError: resendOtpErrorSelector(state)
});

const mapDispatchToProps = (dispatch: any) => ({
    checkUserExists: (payload: ICheckUserExist) => dispatch(checkUserExist(payload)),
    registerUser: (payload: ILoginPayload) => dispatch(register(payload)),
    resendVerifyMail: (payload: ILoginPayload) => dispatch(resendVerifyMail(payload)),
    setAuthenticatedFlag: (flag: boolean) => dispatch(setAuthenticatedFlag(flag)),
    login: (payload: ILoginPayload) => dispatch(login(payload)),
    resendOTP: (payload: IResendOtpPayload) => dispatch(resendOtp(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(SelfRegister);
